import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IconService } from '@isophi/core-ui';
import { Material, MaterialProduct } from '@isophi/teachers-shared';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-material',
    templateUrl: './material.component.html',
    styleUrls: ['./material.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MaterialComponent implements OnChanges, OnDestroy {
  @Input() order: string;

  @Input() title: string;

  @Input() products: MaterialProduct[];

  @Input() materials: Material[][];

  materialIndex = 0;

  product: MaterialProduct;

  private _subs: Subscription[] = [];

  constructor(
    public icons: IconService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['products'] && this.products) {
      this.product = this.products[0];

      this._subs.push(
        this.activatedRoute.queryParams.subscribe((val) => {
          if ((val.material || val.codename)) {
            for (let i = 0; i < this.products.length; i++) {
              if (val.material && this.products[i].id === +val.material) {
                this.materialIndex = i;
                this.product = this.products[i];
                this.cdr.markForCheck();
                break;
              } else if (val.codename && this.products[i].codename === val.codename) {
                this.materialIndex = i;
                this.product = this.products[i];
                this.cdr.markForCheck();
                break;
              }
            }
          }
        })
      )
    }
  }

  ngOnDestroy(): void {
    this._subs.forEach((_sub) => _sub.unsubscribe());
  }

  showMaterial(index: number, product: MaterialProduct): void {
    if (this.materialIndex !== index) {
      this.materialIndex = index;
      this.product = product;
    }
  }
}
